import { CompanyFormData } from '../../types/companies';

export const generateCompanyFormData = (): CompanyFormData => {
  return {
    companyName: '',
    businessTypeId: 1,
    phoneNumber: '',
    prefectureId: 1,
    postCode: '',
    address1: '',
    address2: '',
    address3: '',
    businessHoursStartAt: '',
    businessHoursEndAt: '',
    companyTypeId: 2,
    companyWasteItemIds: [],
  };
};
